import gql from 'graphql-tag';
export const ADD_STRIPE_CUSTOMER_ID = gql`
    mutation addStripeCustomerID($session: ID!){
        addStripeCustomerID(session: $session)
    }
`;